// kW ↔ HP Calculator tool: unit metadata + client-side field validation, used for
// instant inline feedback as the user types. The actual conversion math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (kwHpToolApi) and backend/tools/kw_hp_tool.py.

export const DEFAULT_INPUTS = {
  unit: 'kw',
  value: 100,
};

// 1 HP (mechanical) = 745.699872 W exactly, per SAE convention (not metric HP).
// Order here drives the order results are displayed in.
export const UNITS = [
  { value: 'w', label: 'W', name: 'Watts' },
  { value: 'kw', label: 'kW', name: 'Kilowatts' },
  { value: 'hp', label: 'HP', name: 'Horsepower (mechanical)' },
];

// Power is a non-negative magnitude, so negative values are rejected — unlike the
// RPM to Rad/s Converter's signed value. Upper bound is a wide sanity ceiling.
// Mirrors FIELD_SPECS in backend/core/lookup/kw_hp_specs.py exactly.
export const FIELD_SPECS = [
  { key: 'value', label: 'Value', unit: '', group: 'input', min: 0, max: 1000000000, strictlyPositive: false },
];

export const PRECISION_OPTIONS = [2, 3, 4, 5, 6];
export const DEFAULT_PRECISION = 4;

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return value < 0 ? 'Power cannot be negative.' : `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
